<div class="flex-column gap-32">
    @if (activityResource.isLoading()) {
        <app-card preCardTitle="Cartegraph feature management">
            <div *appCardContent class="settings-header-container">
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            </div>
        </app-card>
    } @else {

        <app-card preCardTitle="Cartegraph management" icon="arrow_back" (iconClicked)="navigateBack()">
            <div *appCardContent class="settings-header-container">
                <div class="settings-header-title">
                    <p>Cartegraph task activity settings</p>
                    <div class="settings-header-subtitle">
                        Enable activities to create work tasks for
                    </div>
                </div>
                <div class="settings-header-actions">
                    <button (click)="toggleAll(true)"
                            mat-stroked-button
                            color="accent">
                        <span>Enable all</span>
                    </button>
                    <button  (click)="toggleAll(false)"
                            mat-stroked-button
                            color="accent">
                        <span>Disable all</span>
                    </button>

                </div>
            </div>
        </app-card>

        @if (activityResource.value(); as activities) {
            <form [formGroup]="form">
                <div formArrayName="selections">
                    <app-card inCardTitle="Activities">
                        <div *appCardContent>
                            @for (activity of activities; track activity.oid) {
                                <app-row-with-toggle
                                        [primaryText]="activity.label"
                                        [secondaryText]="activity.description"
                                        [formControl]="selectionsGroup.controls[activity.oid]"
                                >
                                </app-row-with-toggle>
                            }
                        </div>
                    </app-card>
                </div>
            </form>
        }
    }
</div>
